export type StakeholderCategory = 'people' | 'organisation' | 'ecosystem';

export type StakeholderRegisterRow = {
  group: string;
  stakeholderType: 'Direct' | 'Indirect';
  vulnerabilityLabel: string | null;
  power: string;
  description?: string;
};

export type StakeholderRegisterSection = {
  id: StakeholderCategory;
  title: string;
  description: string;
  rows: StakeholderRegisterRow[];
};

export function countStakeholderRegisterStats(sections: StakeholderRegisterSection[]) {
  let total = 0;
  let vulnerable = 0;
  for (const s of sections) {
    for (const r of s.rows) {
      total += 1;
      if (r.vulnerabilityLabel) vulnerable += 1;
    }
  }
  return { total, vulnerable };
}
